import { IStringFilter, StringFilterTypes } from '@app/models';

import i18next from 'i18next';

export const createStringFilters: IStringFilter[] = [
    { value: StringFilterTypes.is, label: i18next.t('STR_FILTER_IS'), requiresValue: true },
    { value: StringFilterTypes.isnot, label: i18next.t('STR_FILTER_IS_NOT'), requiresValue: true },
    { value: StringFilterTypes.startswith, label: i18next.t('STR_FILTER_STARTS_WITH'), requiresValue: true },
    { value: StringFilterTypes.endswith, label: i18next.t('STR_FILTER_ENDS_WITH'), requiresValue: true },
    { value: StringFilterTypes.contains, label: i18next.t('STR_FILTER_CONTAINS'), requiresValue: true },
    { value: StringFilterTypes.notcontains, label: i18next.t('STR_FILTER_NOT_CONTAINS'), requiresValue: true },
    { value: StringFilterTypes.isempty, label: i18next.t('STR_FILTER_IS_EMPTY'), requiresValue: false },
    { value: StringFilterTypes.notempty, label: i18next.t('STR_FILTER_NOT_EMPTY'), requiresValue: false },
];
